import { useQuery, gql, useLazyQuery } from "@apollo/client"
import { TRAINING_COURSES_FIELDS } from "./fragments/courseFragments"

const TRAINING_COURSES_QUERY = gql`
  query TrainingCourses($filter: TrainingCourseFilter, $orderBy: TrainingCourseOrderByInput) {
    trainingCourses {
      list(filter: $filter, orderBy: $orderBy) {
        ...TrainingCoursesFields
      }
    }
  }
  ${TRAINING_COURSES_FIELDS}
`

const useQueryTrainingCourses = (variables = {}, options = {}) => {
  return useQuery(TRAINING_COURSES_QUERY, {
    variables,
    ...options
  })
}

const useLazyQueryTrainingCourses = (options) => useLazyQuery(TRAINING_COURSES_QUERY, options)

const trainingCourseTypePolicies = {
  TrainingCourse: {
    fields: {
      modules: {
        merge(prev, next) {
          return [...next]
        }
      }
    }
  }
}

export { useQueryTrainingCourses, useLazyQueryTrainingCourses, trainingCourseTypePolicies }
